module.exports = __webpack_public_path__ + "img/dingzhi.622ddc66.webp";